export default "__VITE_ASSET__C0XL5MKF__"